import xhr from 'xhr.js';
import auth from 'services/auth';

const service_users = {
    getNotificationSettings: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/me/notification-settings?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    updateNotificationSettings: async notificationSettings => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/me/notification-settings?account_id=${account_id}`,
            { notification_settings: notificationSettings },
            {
                withCredentials: true
            }
        );

        return res.data;
    },
    updateUserTimezone: async timezone => {
        const res = await xhr.put(
            `/me/timezone`,
            { timezone },
            {
                withCredentials: true
            }
        );

        return res.data;
    }
};

export default service_users;
